// extracted by mini-css-extract-plugin
module.exports = {"form":"Contact--form--v0emL","statusText":"Contact--statusText--3UGgk","error":"Contact--error--1rTid","tempText":"Contact--tempText--26lIx"};